import { render, staticRenderFns } from "./spotGoodsList.vue?vue&type=template&id=29659768&scoped=true"
import script from "./spotGoodsList.vue?vue&type=script&lang=js"
export * from "./spotGoodsList.vue?vue&type=script&lang=js"
import style0 from "./spotGoodsList.vue?vue&type=style&index=0&id=29659768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29659768",
  null
  
)

export default component.exports